import faker from 'faker';
import sample from 'lodash/sample';
import random from 'lodash/random';
export const amount = 200;

export default () => ({
    abbreviation: faker.name.firstName(),
    name: faker.name.lastName(),
    version: 'link',
    targetPopulation: sample(['All', 'Adult', 'Pediatric', 'Proxy-Reported for Pediatric', 'Other']),
    domain: faker.internet.domainName(),
    type: sample(['All', 'CAT standard', 'CAT hybrid', 'CAT video', 'Questionnaire', 'Short Form', 'Other']),
    system: sample(['All', 'Neuro-Qol', 'PROMIS', 'Other']),
    language: sample(['All', 'Dutch', 'English', 'Flemish', 'Swedish']),
    description: 'link',
    settings: 'link',
    itemsAndResponses: 'link',
    price: faker.commerce.price(40, 80, 0),
    cost: faker.commerce.price(10, 40, 0),
    status: sample(['Test', 'Active', 'Recommended', 'Retired']),
    comments: faker.lorem.sentence(),
    sourceItemBankLanguage: faker.random.locale(),
    sourceItemBankVersion: faker.system.semver(),
    sourceItemBankItemParametersDate: faker.date.past(),
    targetItemBankLanguage: faker.random.locale(),
    targetItemBankCode: faker.system.semver(),
    targetItemBankTranslationDate: faker.date.past(),
    targetItemBankImportFile: faker.date.past(),
    targetItemBankParametersDate: faker.date.past(),
    targetItemBankTestSettings: faker.date.past(),
    numberOfDimensions: random(1, 4),
    numberOfItems: random(3, 15) * 10,
    numberOfResponsesMinimum: random(5, 15),
    numberOfResponsesMaximum: random(15, 30),
    engine: sample(['Shadow-CAT V1.1', 'Shadow-CAT V1.0', 'Mirt-CAT V1.0']),
    estimator: sample(['Estimated A-Posteriori (EAP)', 'Maximum A-Posteriori (MAP, default)', 'Maximum Likelihood (ML)']),
    selection: sample(['Maximum Information (MI, default)', 'Shadow Testing (Shadow)']),
    objective: sample(['Trace of the variance-covariance matrix (A)', 'Determinant of the Fisher information matrix (D)', 'Posterior version of trace of the variance-covariance matrix (PA)', 'Posterior version of of the Fisher information matrix (PD, default)', 'Posterior expected Kullback-Leibler distance (PEKL)']),
    startingRulesMinimumNumberOfItems: random(15, 30),
    startingRulesType: sample(['Fixed', 'Random', 'Random by dimension']),
    archivedAt: Math.random() >= 0.5 ? faker.date.recent() : null,
});